import jwt from 'jsonwebtoken'


export const getSession = () => {
    let token = localStorage.getItem('sess_ba') || null
    if(token == null) return null

    let user = jwt.decode(token)
    return user
}